import {gql} from 'apollo-angular';

export const ROOKIEDAY_SUBMIT_RECALL_CARD = gql`
  mutation rookiedaySubmitRecallCard($recallCardData: InRookieDayRecallCard!) {
    rookiedaySubmitRecallCard(recallCardData: $recallCardData) {
      type
      message
    }
  }
`;
